class AbstractCollection {
  /**
   *
   * @param {object|object[]} items
   */
  constructor(items) {
    this.items = null;

    if (items) {
      this.items = items;
    }
  }

  /**
   *
   * @param {*} obj
   * @param {boolean} [throwError=true]
   * @returns {null|Team}
   */
  getItem(obj, throwError = true) {
    let key = Object.keys(obj)[0];

    let items = this.items.filter((team) => team.obj[key] === obj[key]);
    if (items.length === 1) {
      // noinspection JSValidateTypes
      return items[0];
    }

    if (throwError)
      console.error(`found ${items.length} items with ${key}: ${obj[key]}`);

    return null;
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return !!this.items && this.items.every((item) => item.hasLoaded());
  }
}

export default AbstractCollection;
